// extracted by mini-css-extract-plugin
export default {"sectionForm":"queue_sectionForm__AZVSd","input":"queue_input__w8cKQ","buttonReset":"queue_buttonReset__Eh-G0","sectionResult":"queue_sectionResult__IGSUK"};